export const envLinks = {
    local: {
        websiteLink: {
            DACH: 'https://local.tonie.cloud/de-de',
            UKI: 'https://local.tonie.cloud/en-gb',
            FRA: 'https://local.tonie.cloud/fr-fr',
            EUR: 'https://local.tonie.cloud/en-eu',
        },
        retailerLink: {
            DACH: 'https://local.tonie.cloud/de-de/handel',
            UKI: 'https://local.tonie.cloud/en-gb/retailer',
        },
        shopLink: {
            DACH: 'https://local.tonie.cloud/de-de',
            UKI: 'https://local.tonie.cloud/en-gb',
            FRA: 'https://local.tonie.cloud/fr-fr',
            USA: 'https://us.tonies.com/collections/shop-all#tonies',
            EUR: 'https://local.tonie.cloud/en-eu',
        },
        cloudLink: {
            UKI: 'https://my.local.tonie.cloud',
        },
    },
    dev: {
        websiteLink: {
            DACH: 'https://dev.tonie.cloud/de-de',
            UKI: 'https://dev.tonie.cloud/en-gb',
            USA: 'https://dev.tonie.cloud/en-us',
            FRA: 'https://dev.tonie.cloud/fr-fr',
            EUR: 'https://dev.tonie.cloud/en-eu',
        },
        retailerLink: {
            DACH: 'https://dev.tonie.cloud/de-de/handel',
            UKI: 'https://dev.tonie.cloud/en-gb/retailer',
        },
        shopLink: {
            DACH: 'https://dev.tonie.cloud/de-de',
            UKI: 'https://dev.tonie.cloud/en-gb',
            USA: 'https://us.tonies.com/collections/shop-all#tonies',
            FRA: 'https://dev.tonie.cloud/fr-fr',
            EUR: 'https://dev.tonie.cloud/en-eu',
        },
        cloudLink: {
            UKI: 'https://my.dev.tonie.cloud',
        },
    },
    stage: {
        websiteLink: {
            DACH: 'https://stage.tonie.cloud/de-de',
            UKI: 'https://stage.tonie.cloud/en-gb',
            USA: 'https://stage.tonie.cloud/en-us',
            FRA: 'https://stage.tonie.cloud/fr-fr',
            EUR: 'https://stage.tonie.cloud/en-eu',
        },
        retailerLink: {
            DACH: 'https://stage.tonie.cloud/de-de/handel',
            UKI: 'https://stage.tonie.cloud/en-gb/retailer',
        },
        shopLink: {
            DACH: 'https://stage.tonie.cloud/de-de',
            UKI: 'https://stage.tonie.cloud/en-gb',
            USA: 'https://us.tonies.com/collections/shop-all#tonies',
            FRA: 'https://stage.tonie.cloud/fr-fr',
            EUR: 'https://stage.tonie.cloud/en-eu',
        },
        cloudLink: {
            UKI: 'https://my.stage.tonie.cloud',
        },
    },
    prod: {
        websiteLink: {
            DACH: 'https://tonies.com/de-de',
            UKI: 'https://tonies.com/en-gb',
            USA: 'https://tonies.com/en-us',
            FRA: 'https://tonies.com/fr-fr',
            EUR: 'https://tonies.com/en-eu',
        },
        retailerLink: {
            DACH: 'https://tonies.com/de-de/handel',
            UKI: 'https://tonies.com/en-gb/retailer',
        },
        shopLink: {
            DACH: 'https://tonies.com/de-de',
            UKI: 'https://tonies.com/en-gb',
            USA: 'https://us.tonies.com/collections/shop-all#tonies',
            FRA: 'https://tonies.com/fr-fr',
            EUR: 'https://tonies.com/en-eu',
        },
        cloudLink: {
            UKI: 'https://my.tonies.com',
        },
    },
};
